<template lang="pug">
.bulk-send-files-card-table
  h6.mt-4.mb-0(:style='{ fontWeight: "bold", color: "#013D52" }') {{ $t('configureBulkSend.recipients.fileDetails.title') }}
  card-table(:total-items='data.length' breakpoint-size='lg')
    template(v-for='(bulkSend, index) in data' v-slot:[`card-${index}`]='{}')
      info-pill(
        :style='pillStyle(bulkSend.file_result)'
        v-if='bulkSend.file_result'
      ) {{ pillText(bulkSend.file_result) }}

    template(v-slot:table-head)
      th {{ $t('bulkSendsCardTable.name') }}
      th {{ $t('configureBulkSend.recipients.selectedFiles') }}
      th {{ $t('configureBulkSend.recipients.fileDetails.totalRows') }}
      th(:style='{ color: "#19665B" }') {{ $t('configureBulkSend.recipients.fileDetails.validRows') }}
      th(:style='{ color: "#721C24" }') {{ $t('configureBulkSend.recipients.fileDetails.invalidRows') }}

    template(
      v-for='(bulkSend, index) in data'
      v-slot:[`table-row-${index}`]='{}'
    )
      td {{ bulkSend.name }}
      td
        info-pill(
          :style='pillStyle(bulkSend.file_result)'
          v-if='bulkSend.file_result'
        ) {{ pillText(bulkSend.file_result) }}
      td
        info-pill(v-if='bulkSend.file_result') {{ bulkSend.file_result.total_rows }}
      td
        info-pill(
          :style='{ backgroundColor: "#E7F0EF", color: "#19665B" }'
          v-if='bulkSend.file_result'
        ) {{ bulkSend.file_result.valid_rows }}
      td
        info-pill(
          :style='{ backgroundColor: "#F8D7DA", color: "#721C24" }'
          v-if='bulkSend.file_result'
        ) {{ bulkSend.file_result.invalid_rows }}
  .d-flex.justify-content-between.align-items-center.mt-4
    h6.mt-4.mb-0(
      :style='{ fontWeight: "bold", color: "#013D52" }'
      v-if='hasCsvInvalidRows && showFailed'
    ) {{ $t('configureBulkSend.recipients.fileDetails.invalidRows') }}
    .row
      button.disableDraggable(
        :aria-controls='`bulk-send-file-result`'
        :aria-label='$t("configureBulkSend.recipients.collapsable")'
        :data-bs-target='`#bulk-send-file-result`'
        aria-expanded='true'
        data-bs-toggle='collapse'
        type='button'
        v-if='hasCsvInvalidRows && showFailed'
      )
        icon(name='angle-down')
  #bulk-send-file-result.collapse.show
    card-table#failed-csv-rows(
      :total-items='failedRows.length'
      breakpoint-size='lg'
      v-if='showFailed'
    )
      template(v-if='hasCsvInvalidRows' v-slot:table-head)
        th {{ $t('configureBulkSend.recipients.fileDetails.lineNumber') }}
        th {{ $t('configureBulkSend.recipients.fileDetails.cell') }}

      template(
        v-for='(failedRow, index) in failedRows'
        v-slot:[`table-row-${index}`]='{}'
      )
        td
          info-pill {{ failedRow.line_number }}
        td 
          .d-flex.flex-wrap.gap-2
            info-pill(
              :key='`${index}-${cellIndex}`'
              :style='{ backgroundColor: "#F8D7DA", color: "#721C24" }'
              v-for='(cell, cellIndex) in failedRow.failed_cells'
            ) {{ cell.col_name }}: {{ cell.value }}
</template>
<script>
import CardTable from '@/ui/organisms/CardTable.vue';
import InfoPill from '@/modules/business/components/molecules/InfoPill.vue';
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'BulkSendFilesCardTable',
  components: {
    CardTable,
    InfoPill,
    Icon,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    showFailed: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    failedRows() {
      return this.data[0]?.file_result?.failed_rows ?? [];
    },
    hasCsvInvalidRows() {
      const invalidRows = this.data[0]?.file_result?.invalid_rows;
      return invalidRows > 0;
    },
  },
  methods: {
    pillText(result) {
      if (!result.invalid_rows) return result.name;

      const invalidRows = this.$t('bulkSendDetails.summaryCards.invalidRows', {
        total: result.invalid_rows,
      });
      return `${result.name} · ${invalidRows}`;
    },
    pillStyle(result) {
      return result.invalid_rows
        ? { backgroundColor: '#F8D7DA', color: '#721C24' }
        : { backgroundColor: '#E7F0EF', color: '#19665B' };
    },
  },
};
</script>
<style scoped lang="stylus">
.bulk-send-files-card-table :deep(.table-card__item--card)
  padding: 1rem 1rem 1rem 2rem

.bulk-send-files-card-table :deep(.table-card__head th),
.bulk-send-files-card-table :deep(.table-card__item--row td)
  padding-top: 1rem
  padding-bottom: 1rem

.bulk-send-files-card-table :deep(.table-card__head th:first-child),
.bulk-send-files-card-table :deep(.table-card__item--row td:first-child)
  padding-left: 2rem
</style>
